import PropTypes from 'prop-types';
import { Flex, Link, Text as PText } from '@cof/plastic-components';
import { withText } from '../../../../text/textStore';

const HowDoesItWork = ({ Text, Text: text, JsxText }: any) => {
    return (
        <Flex flexDirection="column" data-qa-id="how-does-it-work">
            <PText>
                <Text path="Paragraph1" />
            </PText>
            {/* @ts-expect-error TS2322: Type '"2"' is not assignable to type 'ResponsiveValue<AllowedSpace, DefaultTheme> | undefined'. */}
            <PText mt="2">
                <Text path="Paragraph2" />
            </PText>
            {/* @ts-expect-error TS2322: Type '"2"' is not assignable to type 'ResponsiveValue<AllowedSpace, DefaultTheme> | undefined'. */}
            <PText mt="2" mb="2">
                <JsxText
                    path="Paragraph3"
                    params={{
                        DONE_LINK: (
                            <Link
                                external
                                href={text({ path: 'DOneLink.Target' })}
                                data-qa-id="ob-accept-region-done-link"
                            >
                                {text({ path: 'DOneLink.Text' })}
                            </Link>
                        ),
                        PRIVACY_POLICY_LINK: (
                            <Link
                                external
                                href={text({ path: 'PrivacyPolicyLink.Target' })}
                                data-qa-id="ob-accept-region-privacy-policy-link"
                            >
                                {text({ path: 'PrivacyPolicyLink.Text' })}
                            </Link>
                        )
                    }}
                />
            </PText>
        </Flex>
    );
};

const HowDoesItWorkWithText = withText('HowDoesItWork')(HowDoesItWork);

HowDoesItWork.propTypes = {
    Text: PropTypes.func.isRequired,
    JsxText: PropTypes.func.isRequired
};

export default HowDoesItWorkWithText;
